import { render, staticRenderFns } from "./index.vue?vue&type=template&id=67b07594&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=67b07594&prod&lang=less&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=67b07594&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b07594",
  null
  
)

export default component.exports